import { render, staticRenderFns } from "./DataListSynergyComponent.vue?vue&type=template&id=1e4ce0fc&"
import script from "./DataListSynergyComponent.vue?vue&type=script&lang=js&"
export * from "./DataListSynergyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports